import { IconExclamationTriangle } from "@central-icons-react/round-filled-radius-2-stroke-2/IconExclamationTriangle";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router";
import Footer from "./Footer";
import Header from "./Header";

export default function ErrorScreen() {
  const { t } = useTranslation();
  const error = useRouteError();

  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <div className="flex flex-col min-h-screen bg-background text-primary">
      <Header showProgress={false} />
      <main className="flex-1 container pt-14 pb-24 flex flex-col items-center justify-center">
        <div className="bg-white rounded-2xl shadow-lg/4 p-8 sm:p-12 max-w-lg w-full text-center">
          <div className="w-16 h-16 rounded-full bg-red/10 text-red flex flex-center mx-auto mb-6">
            <IconExclamationTriangle className="size-8" />
          </div>
          <h1 className="text-xl sm:text-2xl font-medium mb-3">
            {isNotFound ? t("error.notFoundTitle") : t("error.title")}
          </h1>
          <p className="text-primary/70 mb-8 leading-relaxed">
            {isNotFound ? t("error.notFoundDescription") : t("error.description")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              className="btn-blue justify-center"
              onClick={() => window.location.reload()}
            >
              {t("error.retry")}
            </button>
            <a href="/" className="btn-outline justify-center">
              {t("error.goHome")}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
